module.exports = __webpack_public_path__ + "img/breaker_on_option_1.008f1366.png";